/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getNotifications = /* GraphQL */ `
  query GetNotifications($username: String!, $type: String!) {
    getNotifications(username: $username, type: $type) {
      type
      username
      content
      sender
    }
  }
`;

export const listNotificationsByUsernameAndStatus = `
query MyQuery($username:String,$status:String) {
  listNotifications(filter: {status: {eq: $status}, username: {eq: $username}}) {
    items {
      content
      sender
      type
      status
      username
    }
  }
}
`;
